import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { UserManager, User, WebStorageStateStore, Log } from 'oidc-client';
import { Constants } from '../constants';
import { Utils } from './utils';
import { AuthContext } from '../model/auth-context';
import { UserInfo } from '../userInfo';
import { Languges } from '../Languages';
import { SimpleClaim } from '../model/simple-claim';
import { AppConfigService } from '../reactive-forms/services/app-config.service';
import { DOCUMENT } from '@angular/common';
import { parseNumber } from '@progress/kendo-angular-intl';
import { SBHttpServicesService } from '../shared/services/sbhttp-services.service';
import { SharedHandlersService } from '../shared/shared-handlers.service';

@Injectable()
export class AuthService {
    private _userManager: UserManager;
    private _user: User;
    authContext: AuthContext;

    constructor(private http: HttpClient, private environment: AppConfigService, @Inject(DOCUMENT) private document: Document, private lang: Languges, public Shared: SharedHandlersService,
        private httpService: SBHttpServicesService) {
        // 
        Log.logger = console;
        var config = {
            authority: this.environment.stsAuthority,
            client_id: this.environment.clientId,
            redirect_uri: `${this.environment.clientRoot}assets/oidc-login-redirect.html`,
            scope: 'openid projects-api profile',
            response_type: 'id_token token',
            post_logout_redirect_uri: `${this.environment.clientRoot}?postLogout=true`,
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            automaticSilentRenew: true,
            silent_redirect_uri: `${this.environment.clientRoot}assets/silent-redirect.html`
        };
        this._userManager = new UserManager(config);
        this._userManager.getUser().then(user => {
            if (user && !user.expired) {
                this._user = user;
                this.loadSecurityContext();
                this.loadUserClaims(user);
            }
        });
        this._userManager.events.addUserLoaded(args => {
            this._userManager.getUser().then(user => {
                this._user = user;
                this.loadSecurityContext();
                this.loadUserClaims(user);
            });
        });
    }

    loadUserClaimsOld(user: User) {
        if (user.profile.BusinessUnit)
            UserInfo.BUID = user.profile.BusinessUnit;
        if (user.profile.BusinessUnitName)
            UserInfo.BusinessUnitName = user.profile.BusinessUnitName;
        if (user.profile.BusinessUnitAName)
            UserInfo.BusinessUnitAName = user.profile.BusinessUnitAName;
        if (user.profile.UserName)
            UserInfo.UserName = user.profile.UserName;
        if (user.profile.Language)
            //UserInfo.Language = Languges.GetLanguageKey(user.profile.Language);
            UserInfo.Language = user.profile.Language;
        if (user.profile.UserCode) {
            UserInfo.CurrentSalesmanNo = user.profile.UserCode;
            UserInfo.UserCode = user.profile.UserCode;
            UserInfo.UserName = user.profile.name;
        }

        ////console.log(user.profile);
        UserInfo.AccessToken = this.getAccessToken();
        if (user.profile) {
            const excluded = ['amr', 'sid', 'sub', 'auth_time', 'idp', 'AspNet.Identity.SecurityStamp', 'name', 'preferred_username'];
            const claims = Object.keys(user.profile)
                .filter(key => !excluded.includes(key))
                .reduce((obj, key) => {
                    obj[key] = user.profile[key];
                    return obj;
                }, {});
            UserInfo.Claims = Object.entries(claims);
            //console.log("Claims");
            //console.log(UserInfo.Claims);
        }
    }

    async login(): Promise<any> {
        // 
        localStorage.setItem('redirectTo', window.location.href);
        return await this._userManager.signinRedirect();
    }
    async resetUser() {
        UserInfo.BUID = null;
        UserInfo.BusinessUnitName = null;
        UserInfo.BusinessUnitAName = null;
        UserInfo.UserName = null;
        UserInfo.Language = this.Shared.SetUserLanguage(2);
        UserInfo.CurrentSalesmanNo = null;
        UserInfo.UserCode = null;
    }

    async loadUserClaims(user: any) {
        // 
        if (user.BusinessUnit)
            UserInfo.BUID = user.BusinessUnit;
        if (user.BusinessUnitName)
            UserInfo.BusinessUnitName = user.BusinessUnitName;
        if (user.BusinessUnitAName)
            UserInfo.BusinessUnitAName = user.BusinessUnitAName;
        if (user.Username)
            UserInfo.UserName = user.Username;
        if (user.Language) {
            UserInfo.Language = this.Shared.SetUserLanguage(user.Language);
            //await this.lang.GetLanguage();
        }
        UserInfo.UserCode = user.UserCode;
        if (user.UserCode) {
            UserInfo.CurrentSalesmanNo = user.UserCode;
            UserInfo.UserName = user.Username;
      }
      if (user.AuthType) {
        UserInfo.AuthType = user.AuthType;
      }
        if (user.Token) {
            UserInfo.AccessToken = user.Token;
            localStorage.setItem("jwt", user.Token);
        }
        if (user.refreshToken) {
            UserInfo.refreshToken = user.refreshToken;
            localStorage.setItem("refreshToken", user.refreshToken);
        }
        if (user.FWToken) {
            UserInfo.FWToken = user.FWToken;
            localStorage.setItem("FWToken", user.FWToken);
        }
        else {
            UserInfo.FWToken = "";
            localStorage.setItem("FWToken", "");
        }
        if (user.ODataToken) {
            UserInfo.ODataToken = user.ODataToken;
            localStorage.setItem("ODataToken", user.ODataToken);
        }
        else {
            UserInfo.ODataToken = "";
            localStorage.setItem("ODataToken", "");
        }
        if (user.BOToken) {
            UserInfo.BOToken = user.BOToken;
            localStorage.setItem("BOToken", user.BOToken);
        }
        else {
            UserInfo.BOToken = "";
            localStorage.setItem("BOToken", "");
        }
        if (localStorage.getItem("BrowserType")) {
            UserInfo.BrowserType = parseNumber(localStorage.getItem("BrowserType"));
        }
        else { UserInfo.BrowserType = 0; }
        if (user) {
            // 
            localStorage.setItem("userinfo", JSON.stringify(user));
            if (UserInfo.Language == 1) {
                //this.isRightToLeft = true;

                this.removeStyle("styleen");
                this.removeStyle("responsive");
                //this.loadStyle("./assets/Theme/css/rtl/style.css", "stylear");
                //this.loadStyle("./assets/Theme/css/rtl/responsive.css", "responsivear");
                const htmlTag = this.document.getElementsByTagName('html')[0];
                htmlTag.setAttribute("dir", "rtl");
            }
            else {

                this.removeStyle("stylear");
                this.removeStyle("responsivear");
                //this.loadStyle("./assets/Theme/css/style.css", "styleen");
                //this.loadStyle("./assets/Theme/css/responsive.css", "responsive");
                const htmlTag = this.document.getElementsByTagName('html')[0];
                htmlTag.setAttribute("dir", "ltr");
            }
        }
    }
    removeStyle(clienttheme: string) {
        // 
        const head = this.document.getElementsByTagName('head')[0];

        let themeLink = this.document.getElementById(
            clienttheme
        ) as HTMLLinkElement;
        if (themeLink)
            head.removeChild(themeLink);
    }


    loadStyle(styleName: string, clienttheme: string) {
        const head = this.document.getElementsByTagName('head')[0];

        let themeLink = this.document.getElementById(
            clienttheme
        ) as HTMLLinkElement;

        if (themeLink) {
            themeLink.href = styleName;
        } else {
            const style = this.document.createElement('link');
            style.id = clienttheme;
            style.rel = 'stylesheet';
            style.href = `${styleName}`;
            style.type = "text/css";
            head.appendChild(style);
        }
    }

    logout(): Promise<any> {
        //  window.localStorage.clear();
        ///clear filter values in local storage
        localStorage.setItem('redirectTo', window.location.href);

        var i, results = [];
        for (i in localStorage) {
            if (localStorage.hasOwnProperty(i)) {
                if (i.match('FilterValues') || (!'FilterValues' && typeof i === 'string')) {
                    localStorage.removeItem(i);
                }
            }
        }
        this.resetUser();
        return this._userManager.signoutRedirect();
    }

    isLoggedIn(): boolean {
        //if (this._user && this._user.profile)
        //	//console.log(this._user.profile);
        return this._user && this._user.access_token && !this._user.expired;
    }
    getUser() {
        return this._user
    }

    getAccessToken(): string {
        return this._user ? this._user.access_token : '';
    }

    signoutRedirectCallback(): Promise<any> {
        return this._userManager.signoutRedirectCallback();
    }

    loadSecurityContext() {
debugger;
        var accessToken = this.getAccessToken();
        var headers = new HttpHeaders().set("Access-Control-Allow-Origin", "*").set('Authorization', `Bearer ${accessToken}`);
        this.httpService.GetDataGenric<SimpleClaim[]>(`${this.environment.apiRoot}api/Account/AuthContext`).subscribe(context => {
            this.authContext = new AuthContext();
            this.authContext.claims = context;
            ////console.log(this.hasPermission("TransferRequest2", PermissionOperation.Read));
        }, error => console.error(Utils.formatError(error)));
        //this.httpClient.get<any[]>(`${this.environment.apiRoot}api/Values/TestBUIDFilter`, { headers: headers }).subscribe(context => {			
        //	//console.log('Order Count: ' + context.length);
        //}, error => console.error(Utils.formatError(error)));
    }

    hasPermission(permission: string, operation: PermissionOperation): boolean {
        if (
            !this.authContext ||
            !this.authContext.claims
        )
            return false;
        return !!this.authContext.claims.find(c => c.type === permission && (c.value.split(':'))[operation] === '1')
    }

}

enum PermissionOperation {
    Read = 0,
    Write = 1,
    Update = 2,
    Delete = 3,
    Execute = 4
}
